import { useQuery } from '@tanstack/react-query';

import { getUrlToBackendApi, request } from '@services/api';

import { ShopItemsResponse, ShopItemsQueryParams } from '@types';

const SHOP_ITEMS_REQUEST_URL = '/shop_items';

export const GET_SHOP_ITEMS_QUERY_KEY = ['shop', 'items'];

export const useQueryShopItems = (queryParams?: ShopItemsQueryParams) => {
	return useQuery<unknown, unknown, ShopItemsResponse>({
		queryKey: [...GET_SHOP_ITEMS_QUERY_KEY, queryParams],
		queryFn: () => {
			const params = new URLSearchParams();

			if (queryParams) {
				if (queryParams.category_ids) {
					queryParams.category_ids.forEach(id => {
						params.append('category_ids[]', id);
					});
				}

				if (queryParams.lang) {
					params.set('lang', queryParams.lang);
				}

				if (queryParams.game) {
					queryParams.game.forEach(v => {
						params.append('game[]', v);
					});
				}

				if (queryParams.rarity) {
					queryParams.rarity.forEach(v => {
						params.append('rarity[]', v);
					});
				}

				if (queryParams.rea_bonus_type) {
					queryParams.rea_bonus_type.forEach(v => {
						params.append('rea_bonus_type[]', v);
					});
				}

				if (queryParams.type) {
					queryParams.type.forEach(v => {
						params.append('type[]', v);
					});
				}

				if (queryParams.order) {
					params.set('order', queryParams.order);
				}

				if (queryParams.page) {
					params.set('page', String(queryParams.page));
				}

				if (queryParams.per_page) {
					params.set('per_page', String(queryParams.per_page));
				}
			}

			return request<ShopItemsResponse>({
				method: 'get',
				url: getUrlToBackendApi(SHOP_ITEMS_REQUEST_URL).href,
				params
			});
		},
		retry: false
	});
};
